<script lang="ts">
  import Text from './Text.svelte';
  import Icon from './Icon.svelte';

  export let label: string;
  export let checked = false;
</script>

<label class="checkbox" class:checked>
  <input class="input" type="checkbox" on:change bind:checked />
  <div class="indicator">
    {#if checked}
      <Icon variant="check" size="large" withMargin={false} />
    {/if}
  </div>
  <Text size="medium" tagName="div">
    {label}
  </Text>
</label>

<style lang="scss">
  @use '../styles/colors';
  @use '../styles/spacing';
  @use '../styles/font-sizes';

  .checkbox {
    align-items: center;
    cursor: pointer;
    display: flex;

    &:first-child {
      margin-top: spacing.$xs;
    }

    &:last-child {
      margin-bottom: spacing.$xs;
    }
  }

  .input {
    opacity: 0;
    width: 1px;
    height: 1px;
  }

  .indicator {
    display: inline-flex;
    background-color: colors.$white100;
    border-radius: 2px;
    border: 1px solid colors.$black10;
    flex-shrink: 0;
    height: 20px;
    width: 20px;
    margin-right: spacing.$s;
  }

  .checked {
    .indicator {
      background-color: colors.$black100;
      border-color: colors.$black100;
      color: colors.$white100;
    }
  }
</style>
